import { render, staticRenderFns } from "./DevamEdenGorevList.vue?vue&type=template&id=a6fc2db8&scoped=true"
import script from "./DevamEdenGorevList.vue?vue&type=script&lang=ts"
export * from "./DevamEdenGorevList.vue?vue&type=script&lang=ts"
import style0 from "./DevamEdenGorevList.vue?vue&type=style&index=0&id=a6fc2db8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6fc2db8",
  null
  
)

export default component.exports